import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { AdjustmentType } from "../models/AdjustmentType";

export const getAdjustmentTypes = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	const resp = await apiService.callV2(
		"[M2].[GetAdjustmentTypes]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as AdjustmentType[];
	} else {
		throw new Error(resp.message || "Error fetching adjustments types");
	}
};
